import React from 'react';
export function AudienceAddIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("g", {
    clipPath: "url(#svg__b609c__clip0)"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.06 15.437C12.453 14.314 14 11.631 14 8.5 14 4.358 11.636 1 7.5 1S1 4.358 1 8.5c0 3.13 1.547 5.813 3.94 6.937-.219.734-1.01 1.027-1.897 1.356C1.641 17.313 0 17.922 0 20.5V23h15v-2.5c0-2.578-1.641-3.187-3.043-3.707-.887-.329-1.678-.622-1.897-1.356zM7.5 14c2.39 0 4.5-2.14 4.5-5.5 0-1.71-.489-3.108-1.248-4.039C10.027 3.573 8.972 3 7.5 3c-1.473 0-2.527.573-3.252 1.461C3.488 5.391 3 6.791 3 8.5 3 11.86 5.11 14 7.5 14z"
  }), React.createElement("path", {
    d: "M18 1h2v3h3v2h-3v3h-2V6h-3V4h3V1zm-2.5 13c1.726 0 3.305-1.116 4.05-3h2.102c-.467 1.604-1.379 2.958-2.603 3.85.058.177.17.298.332.42.272.204.607.35 1.077.556.138.06.289.126.452.2.645.29 1.443.69 2.063 1.404.65.747 1.027 1.74 1.027 3.07V23h-6v-2h4v-.5c0-.92-.248-1.427-.536-1.758-.317-.365-.769-.62-1.374-.893l-.313-.137c-.499-.215-1.117-.483-1.596-.842a2.903 2.903 0 01-.927-1.124A6.068 6.068 0 0115.5 16c-.68 0-1.324-.108-1.925-.309.435-.544.817-1.138 1.14-1.77.257.053.52.079.785.079z"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "svg__b609c__clip0"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
}